/** Level helpers. 0 dBFS = full-scale sine (peak amplitude 1). */

export const DB_FLOOR = -300;

/** 20·log10(a), floored at DB_FLOOR instead of -Infinity. */
export function ampToDb(a: number): number {
  return a > 1e-15 ? 20 * Math.log10(a) : DB_FLOOR;
}

export function dbToAmp(db: number): number {
  return Math.pow(10, db / 20);
}

export function peakAbs(x: ArrayLike<number>, start = 0, end = x.length): number {
  let p = 0;
  for (let i = Math.max(0, start); i < Math.min(end, x.length); i++) {
    const v = Math.abs(x[i]!);
    if (v > p) p = v;
  }
  return p;
}

export function rms(x: ArrayLike<number>, start = 0, end = x.length): number {
  const a = Math.max(0, start);
  const b = Math.min(end, x.length);
  if (b <= a) return 0;
  let s = 0;
  for (let i = a; i < b; i++) s += x[i]! * x[i]!;
  return Math.sqrt(s / (b - a));
}

/** RMS level in dBFS where a full-scale sine reads 0 dBFS (RMS 1/√2 → 0 dB). */
export function rmsDbfs(x: ArrayLike<number>, start = 0, end = x.length): number {
  return ampToDb(rms(x, start, end) * Math.SQRT2);
}
